import price1 from './../img/slider/13.jpg'
import price2 from './../img/slider/82.jpg'
import price3 from './../img/slider/34.jpg'
import price4 from './../img/slider/11.jpg'
import price5 from './../img/slider/24.jpg'
import price6 from './../img/slider/75.jpg'

const prices = [
  {
    img: price1,
    title: '"Quick Christmas Portrait" SPECIAL',
    price: ' €50',
    duration: '20 - 25 minutes',
    description_1: 'Perfect for: Those who want a quick, memorable holiday photo to keep or give as a gift!',
    description_2: "What's included: 2 digital photos. A portrait or family photo, or child's portrait with custom editing, all against festive Christmas decorations.",
    description_3: 'Photo delivery time: 1 to 2 days.',
  },
  {
    img: price2,
    title: '"Christmas Photo Session" SPECIAL',
    price: 'From €100',
    duration: 'up to 1 hours',
    description_1: 'Festive Photo Session with Decorations.',
    description_2: 'Includes 7 digital photos with custom editing. Warm, holiday-themed photos for the whole family, taken in a cozy Christmas setting.',
    description_3: 'Photo delivery time: 7 to 14 days.',
  },
  {
    img: price3,
    title: 'Portrait sessions',
    price: 'From €100',
    duration: 'up to 1 hours',
    description_1: 'Individual, family, and children’s portraits in the studio or outdoors.',
    description_2: 'Includes 5 digital photos with custom editing. Retouching for up to 5 selected photos, if needed.',
    description_3: 'Photo delivery time: 7 to 10 days.',
  },
  {
    img: price4,
    title: 'Family event photography',
    price: 'From €180',
    duration: 'up to 2 hours',
    description_1: 'Photography of birthdays, anniversaries, and other events.',
    description_2: 'Includes a full reportage with key edited shots.',
    description_3: 'Photo delivery time: 10 to 20 days.',
  },
  {
    img: price5,
    title: 'Wedding and celebration photography',
    price: 'From €500',
    duration: 'up to 5 hours',
    description_1: 'Photography of small weddings or private events.',
    description_2: 'Includes detailed shots, portraits with custom editing. Retouching for up to 20 selected digital  photos, if needed.',
    description_3: 'Photo delivery time: 10 to 1 month.',
  },
  {
    img: price6,
    title: 'Commercial photography',
    price: 'From €200',
    duration: 'up to 2 hours',
    description_1: 'Photography for your business, including product shots for websites and marketplaces as well as promotional images.',
    description_2: 'Includes a complete package of all digital photos.',
    description_3: 'Photo delivery time: 10 to 20 days.',
  }
];
export {prices};